var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('guest-header'),_c('div',{staticClass:"landing"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[(_vm.is_loaded)?_c('div',{staticClass:"auth-card"}):_c('loading')],1)])])]),_c('guest-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }